import React, { useEffect } from "react";

const CheckCircleIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#3CAEA3" />
        <path d="M5.5 10.5L8.5 13.5L14.5 7" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SuccessNotification = ({ message, onClose, duration = 4000 }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [onClose, duration]);

    return (
        <div style={{
            position: 'fixed',
            top: '24px',
            right: '24px',
            zIndex: 99999,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: '#fff',
            border: '1px solid #e8e8e8',
            borderRadius: '8px',
            padding: '14px 20px',
            boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
            minWidth: '280px',
            maxWidth: '400px',
        }}>
            <CheckCircleIcon />
            <span style={{ flex: 1, fontSize: '14px', fontWeight: 600, color: '#3CAEA3', fontFamily: 'Hanken Grotesk, sans-serif' }}>
                {message}
            </span>
            <button
                type="button"
                onClick={onClose}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#8D8D8D', fontSize: '16px', lineHeight: 1, padding: 0, marginLeft: '8px' }}
            >
                ✕
            </button>
        </div>
    );
};

export default SuccessNotification;
